import auth from 'b2b-common/services/auth'

export default {
  computed: {
    userData () {
      return auth._clientData
    }
  }
}
